
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"d":"M10.215 2.498h.953c.353 0 .692.143.943.396.25.254.39.638.39.996v1.353M5.048 2.508H3.833c-.353 0-.692.142-.942.396-.25.253-.391.597-.391.956v9.288c0 .358.14.702.39.956s.59.396.943.396h.81m1.071-13h3.631c.368 0 .667.303.667.676v1.64a.68.68 0 0 1-.668.685L5.75 4.5c-.368 0-.702-.31-.702-.684v-1.64c0-.373.298-.676.666-.676Zm1.973 6h5.626A1.2 1.2 0 0 1 14.5 8.712v5.577a1.2 1.2 0 0 1-1.187 1.211H7.687A1.2 1.2 0 0 1 6.5 14.289V8.712A1.2 1.2 0 0 1 7.687 7.5Z","stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    